import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  listingContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    height: 'calc(100vh - 380px)',
    width: '100%',
    margin: theme.spacing(-4),
  },
  formStyle: { display: 'flex', width: '100%' },
  listingForm: {
    height: 'calc(100vh - 380px)',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    width: 'auto',
    minWidth: '545px',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    alignItems: 'flex-start',
    gap: theme.spacing(1.25),
  },
  listingCardForm: {
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    width: 'auto',
    minWidth: '545px',
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    width: '100%',
  },
  cardContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
    margin: theme.spacing(-4),
  },
  formContainer: {
    width: '100%',
  },
  buttonWrapper: {
    display: 'flex',
    gap: theme.spacing(3),
  },
  autosave: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing(5),
    fontSize: '14px',
    color: theme.palette.text.secondary,
    '&.loading': {
      color: theme.palette.info.main,
    },
    '&.success': {
      color: theme.palette.success.main,
    },
    '&.error': {
      color: theme.palette.error.main,
    },
  },
}))
